module.exports = __webpack_public_path__ + "img/classroomPlaceholder.b39f2ac7.png";